import { render } from "./AudienceDetail.vue?vue&type=template&id=4cbf2506&scoped=true"
import script from "./AudienceDetail.vue?vue&type=script&lang=js"
export * from "./AudienceDetail.vue?vue&type=script&lang=js"

import "./AudienceDetail.vue?vue&type=style&index=0&id=4cbf2506&scoped=true&lang=css"
import "./AudienceDetail.vue?vue&type=style&index=1&id=4cbf2506&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbf2506"]])

export default __exports__